import OAuthApplicationForm from './OAuthApplicationForm'

export default OAuthApplicationForm



// WEBPACK FOOTER //
// app/javascript/components/forms/OAuthApplicationForm/index.js